import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Image, Copy } from '@honda-canada/design-system-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import themeStyles from './SpecialOfferCard.styles';
import { useLanguage } from '../../utils/sitecoreContext';
const ModelImageContainer = themeStyles.apply(Box, 'ModelImageContainer');
const ModelImage = ({ modelImage, disclaimerData }) => {
    const { t } = useTranslation();
    const language = useLanguage();
    const formatPriceValue = (value) => formatPrice(value || 0, language, 2);
    return (_jsxs(ModelImageContainer, { children: [_jsx(Image, { "data-testid": "cy-special-offer-card-image", maxWidth: "auto", src: modelImage.src, alt: modelImage.alt }), _jsx(Copy, { "data-testid": "cy-special-offer-card-disclaimer", size: "legal", textAlign: "center", children: t('Pages.SpecialOffers.imageDisclaimerText', {
                    freightAmount: formatPriceValue(disclaimerData === null || disclaimerData === void 0 ? void 0 : disclaimerData.freightAmount),
                    feesAmount: formatPriceValue(disclaimerData === null || disclaimerData === void 0 ? void 0 : disclaimerData.feesAmount),
                    dealerFee: formatPriceValue(disclaimerData === null || disclaimerData === void 0 ? void 0 : disclaimerData.dealerFee),
                }) })] }));
};
export default ModelImage;
